export enum AppMode {
  APP = 'app',
  KIOSK = 'kiosk',
  WIDGET = 'widget',
  WEBSITE = 'website',
}

export enum Country {
  FR = 'fr',
  IT = 'it',
}

export const languages = Object.freeze(['it', 'en', 'de', 'fr', 'es', 'pt'])
export type AppLanguage = (typeof languages)[number]
